import { Observable } from 'rxjs';

export interface IOfflineStorage {
  setItem<T>(
    key: string,
    value: T,
    largeStorageProperty?: string
  ): Observable<unknown>;
  getItem<T>(
    key: string,
    defaultValue?: T,
    largeStorageProperty?: string
  ): Observable<unknown>;
  removeItem(key: string, largeStorageProperty?: string): Observable<unknown>;
}
